






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { Agency } from '@/modules/Agency/interfaces/agency'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'

@Component({
  components: {
    AppSystemInfoCard
  }
})
export default class AgencyDetailAdditional extends Vue {
  @Prop({ type: Object as () => Agency }) readonly agency!: Agency
}
